import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-optimus-message',
    templateUrl: './optimus-message.component.html',
    styleUrls: ['./optimus-message.component.scss'],
})
export class OptimusMessageComponent {}
